module.exports = __webpack_public_path__ + "static/media/check.fcca2b51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/check.svg
// module id = 121
// module chunks = 0